module.exports = __webpack_public_path__ + "img/congratulations／top@2x.a4175bd0.png";